<script>
    import MainTitle404 from "./MainTitle404.svelte";

</script>

<header id="header" class="section">    

    <div class="container box valign-wrapper">
        <MainTitle404/>
    </div> 
</header>

<style>
    #header{background-color: transparent !important;}
    .container.box{
        height: 100vh;
        min-height: 350px;
        justify-content: center;
    }
</style>